import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import z from "zod";
import { generatePassword } from "../utils/clientUtils";

export const clientSchema = z.object({
  first_name: z.string().min(1, "First name is required"),
  last_name: z.string().min(1, "Last name is required"),
  username: z.string().min(1, "Username is required"),
  email: z.string().min(1, "Email is required").email("Invalid email address"),
  password: z.string().optional(),
});

export type ClientAddSchema = z.infer<typeof clientSchema>;

export function useClientForm(isEdit?: boolean) {
  const [showPassword, setShowPassword] = useState(false);

  const form = useForm<ClientAddSchema>({
    resolver: zodResolver(clientSchema),
    defaultValues: {
      first_name: "",
      last_name: "",
      username: "",
      email: "",
      password: "",
    },
  });

  useEffect(() => {
    if (!isEdit) {
      form.setValue("password", generatePassword());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

  const isValid = (() => {
    const v = form.watch();
    const base = !!(v.first_name && v.last_name && v.username && v.email);
    return isEdit ? base : base && !!(v.password && v.password.length > 0);
  })();

  return {
    form,
    showPassword,
    setShowPassword,
    isValid,
  };
}
